import React from 'react';
import { BottomNavigation, BottomNavigationAction, Paper, SvgIcon } from '@mui/material';
import Squares2X2Icon from '@heroicons/react/24/outline/Squares2X2Icon';
import { MOBILE_BOTTOM_NAV_HEIGHT } from './constants';

export const MORE_TAB = '__more__';

export default function MobileBottomNav({ sections, value, onChange, showMore }) {
  return (
    <Paper
      square
      elevation={0}
      sx={{
        flexShrink: 0,
        borderTop: '1px solid',
        borderColor: 'divider',
        pb: 'env(safe-area-inset-bottom)',
        zIndex: (theme) => theme.zIndex.appBar,
      }}
    >
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => onChange(newValue)}
        sx={{
          height: MOBILE_BOTTOM_NAV_HEIGHT,
          bgcolor: 'transparent',
          '& .MuiBottomNavigationAction-root': {
            minWidth: 0,
            px: 0.5,
            color: 'text.secondary',
          },
          '& .Mui-selected': {
            color: 'primary.main',
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: 11,
            fontWeight: 600,
            mt: 0.5,
            '&.Mui-selected': { fontSize: 11 },
          },
        }}
      >
        {sections.map((section) => (
          <BottomNavigationAction
            key={section.key}
            value={section.key}
            label={section.title}
            icon={section.icon}
          />
        ))}
        {showMore && (
          <BottomNavigationAction
            value={MORE_TAB}
            label="More"
            icon={
              <SvgIcon fontSize="small">
                <Squares2X2Icon />
              </SvgIcon>
            }
          />
        )}
      </BottomNavigation>
    </Paper>
  );
}
